// import React, { useMemo, useState } from "react";
// import { Modal, Button, Form, Spinner } from "react-bootstrap";
// import { useTranslation } from "react-i18next";
// import { serviceFields } from "../../Services/serviceFields";
// import "./ServiceEditmodal.css";

// /**
//  * Props:
//  * - show: boolean
//  * - onHide: fn
//  * - order: the order object already loaded in OrderDetailsView
//  * - URL: your API base
//  * - onApplied: fn(resultFromServer)
//  */
// const ServiceEditModal = ({ show, onHide, order, URL, onApplied }) => {
//   const { t } = useTranslation();

//   const [note, setNote] = useState("");
//   const [extraMinutes, setExtraMinutes] = useState(0);
//   const [submitting, setSubmitting] = useState(false);

//   // Numeric increments to add (never negative). We keep ONLY the extra amount here.
//   const [numAdds, setNumAdds] = useState({}); // { prop: addQty }
//   // Boolean turn-ons (only allowed when current is false)
//   const [boolAdds, setBoolAdds] = useState({}); // { prop: true|false }

//   const serviceName = order?.service_name || "";
//   const svcKey = serviceName.trim().toLowerCase();
//   const isTutor = serviceName === "Tutor Service";

//   // ---------- Client-side price tables for live estimate ----------
//   // (These mirror your server pricing so users see what they'll pay.)
//   const PRICE_ELECTRICIAN = {
//     Fan_in_un: 200,
//     Light_in_un: 80,
//     Fan_repair: 150,
//     Light_repair: 70,
//     Doorbell_setup: 120,
//     Exhaust_fan_setup: 200,
//     Exhaust_fan_repair: 150,
//     Drill_wall_holes: 50,
//     Switch_repair: 150,
//     MCB_service: 100,
//     MDB_service: 200,
//     Fan_regulator_in_un: 120,
//     Fan_regulator_repair: 100,
//     Socket_in_un: 150,
//     Socket_repair: 100,
//     Circuit_breaker_repair: 250,
//     New_wiring_point: 350,
//     Full_wiring: 1500,        // boolean (flat)
//     Electrical_checkup: 100   // boolean (flat)
//   };

//   const PRICE_HOME = {
//     bed: 30,
//     kitchen: 20,
//     dra_din: 40,
//     bath: 50,
//     cloth: 10,
//     dish: 10,
//     balcony: 30,
//     window_grill: 40,
//     furniture_cleaning: 60,
//     stairs_and_railing: 40,
//     carpet_cleaning: 50
//   };

//   const PRICE_PLUMBER = {
//     Toilet_in: 250,
//     Faucet_in: 100,
//     Sink_in: 200,
//     Dishwasher_in: 200,
//     Leak_repair: 500,
//     Faucet_repair: 100,
//     Toilet_repair: 100,
//     Shower_repair: 100,
//     Drain_cleaning: 150,
//     pipe_cleaning: 300,
//     tank_cleaning: 800,
//     geyser_setup: 1200,
//     geyser_repair: 800,
//     issue_checkup: 250 // boolean
//   };

//   const PRICE_GAS = {
//     NewchulaSetup: 500,
//     chulaSetup: 300,
//     burnerSetup: 200,
//     burnerCleaning: 150,
//     nozzleReplacement: 120,
//     checkIssues: 100 // boolean
//   };

//   const PRICE_FILTER = {
//     new_filter_setup: 500,
//     installation_filter: 300,
//     uninstallation_filter: 200,
//     kit_replacement: 150,
//     pipe_leak_or_replace: 120,
//     full_servicing: 400,
//     check_up: 100 // boolean
//   };

//   const PRICE_MAP = {
//     "electrician": PRICE_ELECTRICIAN,
//     "home cleaning": PRICE_HOME,
//     "plumber": PRICE_PLUMBER,
//     "gas chula": PRICE_GAS,
//     "filter": PRICE_FILTER
//     // tutor service -> no add-on pricing here (0)
//   };

//   // AC dynamic pricing (depends on order.acTon)
//   const AC_TABLES = {
//     new_setup:      { "1": 2000, "1.5": 2000, "2": 2500, "2.5": 3000 },
//     installation:   { "1": 1800, "1.5": 1800, "2": 2200, "2.5": 2600 },
//     uninstallation: { "1": 700,  "1.5": 700,  "2": 900,  "2.5": 1000 },
//     gas_refill:     { "1": 1500, "1.5": 1600, "2": 2000, "2.5": 2400 },
//     cleaning:       { "1": 550,  "1.5": 550,  "2": 650,  "2.5": 700  },
//     issue_checkup:  300
//   };
//   const resolveTon = (rawTon) => {
//     const t = String(rawTon || "1");
//     return ["1","1.5","2","2.5"].includes(t) ? t : "1";
//   };
//   const acUnit = (ton, code) => {
//     if (code === "issue_checkup") return AC_TABLES.issue_checkup;
//     const tb = AC_TABLES[code];
//     if (!tb) return 0;
//     return tb[resolveTon(ton)] || 0;
//   };

//   // Build editable field list from serviceFields for this service (hook must never be conditional)
//   const editableFields = useMemo(() => {
//     const fields = serviceFields[serviceName] || [];
//     // Only allow number & boolean types in this modal
//     return fields.filter((f) => f.type === "number" || f.type === "boolean");
//   }, [serviceName]);

//   // Helpers (no early returns before hooks)
//   const currentValue = (prop) => (order ? order[prop] : undefined);

//   // Stepper helpers: value shown to user is (current + add). We store only "add".
//   const inc = (prop) => {
//     setNumAdds((prev) => ({
//       ...prev,
//       [prop]: Math.max(0, (prev[prop] || 0) + 1),
//     }));
//   };
//   const dec = (prop /*cur not needed here*/) => {
//     // Decrease the "add" amount, but not below 0 (so total never below current)
//     setNumAdds((prev) => ({
//       ...prev,
//       [prop]: Math.max(0, (prev[prop] || 0) - 1),
//     }));
//   };

//   const handleNumberTyped = (prop, typed, cur) => {
//     // Clamp typed total to be >= current
//     const total = isNaN(typed) ? cur : Math.max(cur, typed);
//     const add = Math.max(0, total - cur);
//     setNumAdds((prev) => ({ ...prev, [prop]: add }));
//   };

//   const handleBoolChange = (prop, val) => {
//     // only "No change" (false) or "Add (Yes)" (true)
//     setBoolAdds((prev) => ({ ...prev, [prop]: val }));
//   };

//   // Build the payload for server (only include actual additions)
//   const buildItemsPayload = () => {
//     const items = [];

//     // number fields: include only when user added > 0 (we send the increment)
//     editableFields
//       .filter((f) => f.type === "number")
//       .forEach((f) => {
//         const addQty = Number(numAdds[f.prop] || 0);
//         if (addQty > 0) {
//           items.push({
//             code: f.prop,
//             title: t(f.labelKey),
//             qty: addQty,
//           });
//         }
//       });

//     // boolean fields: include only when currently false AND user selected "Add"
//     editableFields
//       .filter((f) => f.type === "boolean")
//       .forEach((f) => {
//         const cur = !!currentValue(f.prop);
//         const wantYes = !!boolAdds[f.prop];
//         if (!cur && wantYes) {
//           items.push({
//             code: f.prop,
//             title: t(f.labelKey),
//             qty: 1,
//           });
//         }
//       });

//     return items;
//   };

//   const selectedCount = useMemo(
//     () => buildItemsPayload().length,
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//     [numAdds, boolAdds, editableFields]
//   );

//   // ---------- Live estimate ----------
//   const estimatedDelta = useMemo(() => {
//     let sum = 0;

//     // numeric increments
//     editableFields
//       .filter((f) => f.type === "number")
//       .forEach((f) => {
//         const add = Number(numAdds[f.prop] || 0);
//         if (add <= 0) return;

//         if (svcKey === "ac service") {
//           sum += acUnit(order?.acTon, f.prop) * add;
//         } else {
//           const unit = PRICE_MAP[svcKey]?.[f.prop] ?? 0;
//           sum += unit * add;
//         }
//       });

//     // boolean: add one-time cost only if currently false and user selected "yes"
//     editableFields
//       .filter((f) => f.type === "boolean")
//       .forEach((f) => {
//         const cur = !!currentValue(f.prop);
//         const wantYes = !!boolAdds[f.prop];
//         if (!cur && wantYes) {
//           if (svcKey === "ac service") {
//             sum += acUnit(order?.acTon, f.prop);
//           } else {
//             sum += (PRICE_MAP[svcKey]?.[f.prop] ?? 0);
//           }
//         }
//       });

//     // Extra minutes charge (set here if you decide to charge on UI preview; server is source of truth anyway)
//     // const PER_MIN = 0; // match your server EXTRA_MINUTE_PRICE
//     // sum += (Number(extraMinutes) || 0) * PER_MIN;

//     return sum;
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [svcKey, numAdds, boolAdds, editableFields, order?.acTon, extraMinutes]);

//   const submit = async () => {
//     const items = buildItemsPayload();
//     if (items.length === 0 && Number(extraMinutes) <= 0 && !note.trim()) {
//       alert("Add at least one item or select extra time.");
//       return;
//     }

//     setSubmitting(true);
//     try {
//       const token = localStorage.getItem("token");
//       const resp = await fetch(
//         `${URL}/orders/${order?.order_number}/change-requests`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             ...(token ? { Authorization: `Bearer ${token}` } : {}),
//           },
//           body: JSON.stringify({
//             serviceType: serviceName,
//             proposedBy: "user",
//             items,
//             extraMinutes: Number(extraMinutes) || 0,
//             note: note.trim(),
//           }),
//         }
//       );

//       if (!resp.ok) {
//         const txt = await resp.text();
//         throw new Error(txt || "Failed to submit change request");
//       }
//       const data = await resp.json();

//       onApplied?.(data);
//     } catch (e) {
//       console.error(e);
//       alert("Failed to submit. Please try again.");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const closeAndReset = () => {
//     setNumAdds({});
//     setBoolAdds({});
//     setExtraMinutes(0);
//     setNote("");
//     onHide();
//   };

//   // Safe guards (UI will still render even if order is not yet present, but with blanks)
//   const orderNumber = order?.order_number || "—";
//   const currentTotal = Number(order?.price ?? 0);
//   const prettyDeadline =
//     order?.deadline ? new Date(order.deadline).toLocaleString() : null;

//   return (
//     <Modal
//       show={show}
//       onHide={closeAndReset}
//       centered
//       dialogClassName="service-edit-modal"
//     >
//       <Modal.Header closeButton>
//         <Modal.Title>Edit Order (Add-ons)</Modal.Title>
//       </Modal.Header>

//       <Modal.Body>
//         <div className="service-edit-summary">
//           <div>
//             <strong>Order#:</strong> {orderNumber}
//           </div>
//           <div>
//             <strong>Service:</strong> {serviceName || "—"}
//           </div>
//           <div>
//             <strong>Current Total:</strong> {currentTotal} tk
//           </div>
//           {prettyDeadline && (
//             <div>
//               <strong>Deadline:</strong> {prettyDeadline}
//             </div>
//           )}
//           {isTutor && (
//             <div className="service-edit-tip">
//               Tutor add-ons don’t change commission (as per your policy).
//             </div>
//           )}
//         </div>

//         <hr />

//         {/* Editable numeric fields (show current value inside the input; user can only increase) */}
//         {editableFields.some((f) => f.type === "number") && (
//           <>
//             <h6 className="service-edit-section">Add Quantities</h6>
//             <div className="service-edit-grid">
//               {editableFields
//                 .filter((f) => f.type === "number")
//                 .map((f) => {
//                   const cur = Number(currentValue(f.prop) || 0);
//                   const add = Number(numAdds[f.prop] || 0);
//                   const shownTotal = cur + add;
//                   return (
//                     <div key={f.prop} className="service-edit-row">
//                       <div className="service-edit-label">{t(f.labelKey)}</div>

//                       <div className="service-edit-stepper">
//                         <button
//                           className="stepper-btn"
//                           onClick={() => dec(f.prop)}
//                           disabled={add <= 0}
//                           aria-label="decrease"
//                         >
//                           −
//                         </button>

//                         <input
//                           type="number"
//                           className="stepper-input"
//                           value={shownTotal}
//                           min={cur}
//                           onChange={(e) =>
//                             handleNumberTyped(
//                               f.prop,
//                               parseInt(e.target.value || "0", 10),
//                               cur
//                             )
//                           }
//                         />

//                         <button
//                           className="stepper-btn"
//                           onClick={() => inc(f.prop)}
//                           aria-label="increase"
//                         >
//                           +
//                         </button>
//                       </div>
//                     </div>
//                   );
//                 })}
//             </div>
//           </>
//         )}

//         {/* Editable boolean fields */}
//         {editableFields.some((f) => f.type === "boolean") && (
//           <>
//             <h6 className="service-edit-section">Add Options</h6>
//             <div className="service-edit-grid">
//               {editableFields
//                 .filter((f) => f.type === "boolean")
//                 .map((f) => {
//                   const cur = !!currentValue(f.prop);
//                   const choice = !!boolAdds[f.prop];
//                   return (
//                     <div key={f.prop} className="service-edit-row">
//                       <div className="service-edit-label">{t(f.labelKey)}</div>
//                       <div>
//                         {cur ? (
//                           <span className="service-edit-tag">Already: Yes</span>
//                         ) : (
//                           <Form.Select
//                             className="service-edit-select"
//                             value={choice ? "yes" : "no"}
//                             onChange={(e) =>
//                               handleBoolChange(
//                                 f.prop,
//                                 e.target.value === "yes"
//                               )
//                             }
//                           >
//                             <option value="no">No change</option>
//                             <option value="yes">Add (set to Yes)</option>
//                           </Form.Select>
//                         )}
//                       </div>
//                     </div>
//                   );
//                 })}
//             </div>
//           </>
//         )}

//         {/* Extra time */}
//         <h6 className="service-edit-section">Extra Time (optional)</h6>
//         <Form.Select
//           value={extraMinutes}
//           onChange={(e) => setExtraMinutes(parseInt(e.target.value, 10))}
//         >
//           <option value={0}>No extra time</option>
//           <option value={15}>+15 minutes</option>
//           <option value={30}>+30 minutes</option>
//           <option value={60}>+60 minutes</option>
//           <option value={120}>+120 minutes</option>
//         </Form.Select>

//         {/* Note */}
//         <h6 className="service-edit-section">Note (optional)</h6>
//         <Form.Control
//           as="textarea"
//           rows={3}
//           placeholder="Describe the new items/needs (optional)"
//           value={note}
//           onChange={(e) => setNote(e.target.value)}
//         />

//         {/* Selection summary + price estimate */}
//         <div className="service-edit-summary mt-3">
//           <div><strong>Selected add-ons:</strong> {selectedCount} item(s)</div>
//           <div><strong>Estimated extra:</strong> {estimatedDelta} tk</div>
//           <div><strong>New total:</strong> {currentTotal + estimatedDelta} tk</div>
//         </div>
//       </Modal.Body>

//       <Modal.Footer>
//         <Button variant="secondary" onClick={closeAndReset} disabled={submitting}>
//           Close
//         </Button>
//         <Button variant="primary" onClick={submit} disabled={submitting}>
//           {submitting ? (
//             <>
//               <Spinner animation="border" size="sm" style={{ marginRight: 8 }} />
//               Submitting...
//             </>
//           ) : (
//             "Submit for approval"
//           )}
//         </Button>
//       </Modal.Footer>
//     </Modal>
//   );
// };

// export default ServiceEditModal;






// import React, { useMemo, useState } from "react";
// import { Modal, Button, Form, Spinner } from "react-bootstrap";
// import { useTranslation } from "react-i18next";
// import { serviceFields } from "../../Services/serviceFields";
// import "./ServiceEditmodal.css";

// /* -------------------- Pricing & helpers (module scope; stable) -------------------- */
// const PRICE_ELECTRICIAN = {
//   Fan_in_un: 200,
//   Light_in_un: 80,
//   Fan_repair: 150,
//   Light_repair: 70,
//   Doorbell_setup: 120,
//   Exhaust_fan_setup: 200,
//   Exhaust_fan_repair: 150,
//   Drill_wall_holes: 50,
//   Switch_repair: 150,
//   MCB_service: 100,
//   MDB_service: 200,
//   Fan_regulator_in_un: 120,
//   Fan_regulator_repair: 100,
//   Socket_in_un: 150,
//   Socket_repair: 100,
//   Circuit_breaker_repair: 250,
//   New_wiring_point: 350,
//   Coil_repair: 800,
//   // Full_wiring: 1500, // boolean (flat)
//   Electrical_checkup: 100, // boolean (flat)
// };

// const PRICE_HOME = {
//   bed: 30,
//   kitchen: 20,
//   dra_din: 40,
//   bath: 50,
//   cloth: 10,
//   dish: 10,
//   balcony: 30,
//   window_grill: 40,
//   furniture_cleaning: 60,
//   stairs_and_railing: 40,
//   carpet_cleaning: 50,
// };

// const PRICE_PLUMBER = {
//   Toilet_in: 250,
//   Faucet_in: 100,
//   Sink_in: 200,
//   Dishwasher_in: 200,
//   Leak_repair: 500,
//   Faucet_repair: 100,
//   Toilet_repair: 100,
//   Shower_repair: 100,
//   Drain_cleaning: 150,
//   pipe_cleaning: 300,
//   tank_cleaning: 800,
//   geyser_setup: 1200,
//   geyser_repair: 800,
//   issue_checkup: 250, // boolean
// };

// const PRICE_GAS = {
//   NewchulaSetup: 500,
//   chulaSetup: 300,
//   burnerSetup: 200,
//   burnerCleaning: 150,
//   nozzleReplacement: 120,
//   checkIssues: 100, // boolean
// };

// const PRICE_FILTER = {
//   new_filter_setup: 500,
//   installation_filter: 300,
//   uninstallation_filter: 200,
//   kit_replacement: 150,
//   pipe_leak_or_replace: 120,
//   full_servicing: 400,
//   check_up: 100, // boolean
// };

// const PRICE_MAP = {
//   electrician: PRICE_ELECTRICIAN,
//   "home cleaning": PRICE_HOME,
//   plumber: PRICE_PLUMBER,
//   "gas chula": PRICE_GAS,
//   filter: PRICE_FILTER,
// };

// const AC_TABLES = {
//   new_setup: { 1: 2000, 1.5: 2000, 2: 2500, 2.5: 3000 },
//   installation: { 1: 1800, 1.5: 1800, 2: 2200, 2.5: 2600 },
//   uninstallation: { 1: 700, 1.5: 700, 2: 900, 2.5: 1000 },
//   gas_refill: { 1: 1500, 1.5: 1600, 2: 2000, 2.5: 2400 },
//   cleaning: { 1: 550, 1.5: 550, 2: 650, 2.5: 700 },
//   issue_checkup: 300,
// };
// const resolveTon = (rawTon) => {
//   const t = String(rawTon || "1");
//   return ["1", "1.5", "2", "2.5"].includes(t) ? t : "1";
// };
// const acUnit = (ton, code) => {
//   if (code === "issue_checkup") return AC_TABLES.issue_checkup;
//   const tb = AC_TABLES[code];
//   if (!tb) return 0;
//   return tb[resolveTon(ton)] || 0;
// };
// /* ---------------------------------------------------------------------------------- */

// const ServiceEditModal = ({ show, onHide, order, URL, onApplied }) => {
//   const { t } = useTranslation();

//   const [note, setNote] = useState("");
//   const [extraMinutes, setExtraMinutes] = useState(0);
//   const [submitting, setSubmitting] = useState(false);

//   // Numeric increments to add (never negative). We keep ONLY the extra amount here.
//   const [numAdds, setNumAdds] = useState({}); // { prop: addQty }
//   // Boolean turn-ons (only allowed when current is false)
//   const [boolAdds, setBoolAdds] = useState({}); // { prop: true|false }

//   const serviceName = order?.service_name || "";
//   const svcKey = serviceName.trim().toLowerCase();
//   const isTutor = serviceName === "Tutor Service";

//   // Build editable field list from serviceFields for this service
//   const editableFields = useMemo(() => {
//     const fields = serviceFields[serviceName] || [];
//     // Only allow number & boolean types in this modal
//     return fields.filter((f) => f.type === "number" || f.type === "boolean");
//   }, [serviceName]);

//   // Stepper helpers: value shown to user is (current + add). We store only "add".
//   const inc = (prop) => {
//     setNumAdds((prev) => ({
//       ...prev,
//       [prop]: Math.max(0, (prev[prop] || 0) + 1),
//     }));
//   };
//   const dec = (prop) => {
//     setNumAdds((prev) => ({
//       ...prev,
//       [prop]: Math.max(0, (prev[prop] || 0) - 1),
//     }));
//   };

//   const handleNumberTyped = (prop, typed, cur) => {
//     // Clamp typed total to be >= current
//     const total = isNaN(typed) ? cur : Math.max(cur, typed);
//     const add = Math.max(0, total - cur);
//     setNumAdds((prev) => ({ ...prev, [prop]: add }));
//   };

//   const handleBoolChange = (prop, val) => {
//     // only "No change" (false) or "Add (Yes)" (true)
//     setBoolAdds((prev) => ({ ...prev, [prop]: val }));
//   };

//   // Build the payload for server (only include actual additions)
//   const buildItemsPayload = () => {
//     const items = [];

//     // number fields: include only when user added > 0 (we send the increment)
//     editableFields
//       .filter((f) => f.type === "number")
//       .forEach((f) => {
//         const addQty = Number(numAdds[f.prop] || 0);
//         if (addQty > 0) {
//           items.push({
//             code: f.prop,
//             title: t(f.labelKey),
//             qty: addQty,
//           });
//         }
//       });

//     // boolean fields: include only when currently false AND user selected "Add"
//     editableFields
//       .filter((f) => f.type === "boolean")
//       .forEach((f) => {
//         const cur = !!(order ? order[f.prop] : undefined);
//         const wantYes = !!boolAdds[f.prop];
//         if (!cur && wantYes) {
//           items.push({
//             code: f.prop,
//             title: t(f.labelKey),
//             qty: 1,
//           });
//         }
//       });

//     return items;
//   };

//   // Count of selected add-ons (no dependency on buildItemsPayload)
//   const selectedCount = useMemo(() => {
//     let count = 0;
//     editableFields.forEach((f) => {
//       if (f.type === "number") {
//         const add = Number(numAdds[f.prop] || 0);
//         if (add > 0) count++;
//       } else if (f.type === "boolean") {
//         const cur = !!(order ? order[f.prop] : undefined);
//         const wantYes = !!boolAdds[f.prop];
//         if (!cur && wantYes) count++;
//       }
//     });
//     return count;
//   }, [editableFields, numAdds, boolAdds, order]);

//   // ---------- Live estimate ----------
//   const estimatedDelta = useMemo(() => {
//     let sum = 0;

//     // numeric increments
//     editableFields
//       .filter((f) => f.type === "number")
//       .forEach((f) => {
//         const add = Number(numAdds[f.prop] || 0);
//         if (add <= 0) return;

//         if (svcKey === "ac service") {
//           sum += acUnit(order?.acTon, f.prop) * add;
//         } else {
//           const unit = PRICE_MAP[svcKey]?.[f.prop] ?? 0;
//           sum += unit * add;
//         }
//       });

//     // boolean: add one-time cost only if currently false and user selected "yes"
//     editableFields
//       .filter((f) => f.type === "boolean")
//       .forEach((f) => {
//         const cur = !!(order ? order[f.prop] : undefined);
//         const wantYes = !!boolAdds[f.prop];
//         if (!cur && wantYes) {
//           if (svcKey === "ac service") {
//             sum += acUnit(order?.acTon, f.prop);
//           } else {
//             sum += PRICE_MAP[svcKey]?.[f.prop] ?? 0;
//           }
//         }
//       });

//     // If you ever price extraMinutes on UI, add here. Server remains source of truth.

//     return sum;
//   }, [editableFields, numAdds, boolAdds, svcKey, order]);

//   const submit = async () => {
//     const items = buildItemsPayload();
//     if (items.length === 0 && Number(extraMinutes) <= 0 && !note.trim()) {
//       alert(t("serviceEditModal.alerts.noItems"));
//       return;
//     }

//     setSubmitting(true);
//     try {
//       const token = localStorage.getItem("token");
//       const resp = await fetch(
//         `${URL}/orders/${order?.order_number}/change-requests`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             ...(token ? { Authorization: `Bearer ${token}` } : {}),
//           },
//           body: JSON.stringify({
//             serviceType: serviceName,
//             proposedBy: "user",
//             items,
//             extraMinutes: Number(extraMinutes) || 0,
//             note: note.trim(),
//           }),
//         }
//       );

//       if (!resp.ok) {
//         const txt = await resp.text();
//         throw new Error(txt || t("serviceEditModal.alerts.submitFailed"));
//       }
//       const data = await resp.json();

//       onApplied?.(data);
//     } catch (e) {
//       console.error(e);
//       alert(t("serviceEditModal.alerts.submitFailed"));
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const closeAndReset = () => {
//     setNumAdds({});
//     setBoolAdds({});
//     setExtraMinutes(0);
//     setNote("");
//     onHide();
//   };

//   // Safe guards (UI will still render even if order is not yet present, but with blanks)
//   const orderNumber = order?.order_number || "—";
//   const currentTotal = Number(order?.price ?? 0);
//   const prettyDeadline = order?.deadline
//     ? new Date(order.deadline).toLocaleString()
//     : null;

//   return (
//     <Modal
//       show={show}
//       onHide={closeAndReset}
//       centered
//       dialogClassName="service-edit-modal"
//     >
//       <Modal.Header closeButton>
//         <Modal.Title>{t("serviceEditModal.title")}</Modal.Title>
//       </Modal.Header>

//       <Modal.Body>
//         <div className="service-edit-summary">
//           <div>
//             <strong>{t("serviceEditModal.summary.orderNumber")}</strong>{" "}
//             {orderNumber}
//           </div>
//           <div>
//             <strong>{t("serviceEditModal.summary.service")}</strong>{" "}
//             {serviceName || "—"}
//           </div>
//           <div>
//             <strong>{t("serviceEditModal.summary.currentTotal")}</strong>{" "}
//             {currentTotal} tk
//           </div>
//           {prettyDeadline && (
//             <div>
//               <strong>{t("serviceEditModal.summary.deadline")}</strong>{" "}
//               {prettyDeadline}
//             </div>
//           )}
//           {isTutor && (
//             <div className="service-edit-tip">
//               {t("serviceEditModal.summary.tutorTip")}
//             </div>
//           )}
//         </div>

//         <hr />

//         {/* Editable numeric fields (show current value inside the input; user can only increase) */}
//         {editableFields.some((f) => f.type === "number") && (
//           <>
//             <h6 className="service-edit-section">
//               {t("serviceEditModal.sections.addQuantities")}
//             </h6>
//             <div className="service-edit-grid">
//               {editableFields
//                 .filter((f) => f.type === "number")
//                 .map((f) => {
//                   const cur = Number(order ? order[f.prop] || 0 : 0);
//                   const add = Number(numAdds[f.prop] || 0);
//                   const shownTotal = cur + add;
//                   return (
//                     <div key={f.prop} className="service-edit-row">
//                       <div className="service-edit-label">{t(f.labelKey)}</div>

//                       <div className="service-edit-stepper">
//                         <button
//                           className="stepper-btn"
//                           onClick={() => dec(f.prop)}
//                           disabled={add <= 0}
//                           aria-label="decrease"
//                         >
//                           −
//                         </button>

//                         <input
//                           type="number"
//                           className="stepper-input"
//                           value={shownTotal}
//                           min={cur}
//                           onChange={(e) =>
//                             handleNumberTyped(
//                               f.prop,
//                               parseInt(e.target.value || "0", 10),
//                               cur
//                             )
//                           }
//                         />

//                         <button
//                           className="stepper-btn"
//                           onClick={() => inc(f.prop)}
//                           aria-label="increase"
//                         >
//                           +
//                         </button>
//                       </div>
//                     </div>
//                   );
//                 })}
//             </div>
//           </>
//         )}

//         {/* Editable boolean fields */}
//         {editableFields.some((f) => f.type === "boolean") && (
//           <>
//             <h6 className="service-edit-section">
//               {t("serviceEditModal.sections.addOptions")}
//             </h6>
//             <div className="service-edit-grid">
//               {editableFields
//                 .filter((f) => f.type === "boolean")
//                 .map((f) => {
//                   const cur = !!(order ? order[f.prop] : undefined);
//                   const choice = !!boolAdds[f.prop];
//                   return (
//                     <div key={f.prop} className="service-edit-row">
//                       <div className="service-edit-label">{t(f.labelKey)}</div>
//                       <div>
//                         {cur ? (
//                           <span className="service-edit-tag">
//                             {t("serviceEditModal.booleanOptions.alreadyYes")}
//                           </span>
//                         ) : (
//                           <Form.Select
//                             className="service-edit-select"
//                             value={choice ? "yes" : "no"}
//                             onChange={(e) =>
//                               handleBoolChange(f.prop, e.target.value === "yes")
//                             }
//                           >
//                             <option value="no">
//                               {t("serviceEditModal.booleanOptions.noChange")}
//                             </option>
//                             <option value="yes">
//                               {t("serviceEditModal.booleanOptions.addYes")}
//                             </option>
//                           </Form.Select>
//                         )}
//                       </div>
//                     </div>
//                   );
//                 })}
//             </div>
//           </>
//         )}

//         {/* Extra time */}
//         {order?.status !== "In-Progress" && (
//           <>
//             <h6 className="service-edit-section">
//               {t("serviceEditModal.sections.extraTime")}
//             </h6>
//             <Form.Select
//               value={extraMinutes}
//               onChange={(e) => setExtraMinutes(parseInt(e.target.value, 10))}
//             >
//               <option value={0}>
//                 {t("serviceEditModal.extraTimeOptions.none")}
//               </option>
//               <option value={15}>
//                 {t("serviceEditModal.extraTimeOptions.15minutes")}
//               </option>
//               <option value={30}>
//                 {t("serviceEditModal.extraTimeOptions.30minutes")}
//               </option>
//               <option value={60}>
//                 {t("serviceEditModal.extraTimeOptions.60minutes")}
//               </option>
//               <option value={120}>
//                 {t("serviceEditModal.extraTimeOptions.120minutes")}
//               </option>
//             </Form.Select>
//           </>
//         )}

//         {/* Note */}
//         {/* <h6 className="service-edit-section">
//           {t("serviceEditModal.sections.note")}
//         </h6>
//         <Form.Control
//           as="textarea"
//           rows={3}
//           placeholder={t("serviceEditModal.notePlaceholder")}
//           value={note}
//           onChange={(e) => setNote(e.target.value)}
//         /> */}

//         {/* Selection summary + price estimate */}
//         <div className="service-edit-summary mt-3">
//           <div>
//             <strong>
//               {t("serviceEditModal.summaryFields.selectedAddOns")}
//             </strong>{" "}
//             {selectedCount} item(s)
//           </div>
//           <div>
//             <strong>
//               {t("serviceEditModal.summaryFields.estimatedExtra")}
//             </strong>{" "}
//             {estimatedDelta} tk
//           </div>
//           <div>
//             <strong>{t("serviceEditModal.summaryFields.newTotal")}</strong>{" "}
//             {currentTotal + estimatedDelta} tk
//           </div>
//         </div>
//       </Modal.Body>

//       <Modal.Footer>
//         <Button
//           variant="secondary"
//           onClick={closeAndReset}
//           disabled={submitting}
//         >
//           {t("serviceEditModal.buttons.close")}
//         </Button>
//         <Button variant="primary" onClick={submit} disabled={submitting}>
//           {submitting ? (
//             <>
//               <Spinner
//                 animation="border"
//                 size="sm"
//                 style={{ marginRight: 8 }}
//               />
//               {t("serviceEditModal.buttons.submitting")}
//             </>
//           ) : (
//             t("serviceEditModal.buttons.submit")
//           )}
//         </Button>
//       </Modal.Footer>
//     </Modal>
//   );
// };

// export default ServiceEditModal;











// ***** new Update with pricing and servicePricing.js (22-Oct-2025) ***** //
// import React, { useMemo, useState, useCallback  } from "react";
// import { Modal, Button, Form, Spinner } from "react-bootstrap";
// import { useTranslation } from "react-i18next";
// import { serviceFields } from "../../Services/serviceFields";
// import {
//   SERVICE_PRICING,
//   AC_PRICING,
// } from "../../Services/servicePricing";
// import "./ServiceEditmodal.css";

// /* ----------------------------- field → pricing-key mappings ----------------------------- */
// // Electrician
// // const MAP_ELECTRICIAN = {
// //   ceiling_fan_installation:       "ceilingFanInstallation",
// //   ceiling_fan_uninstallation:     "ceilingFanUninstallation",
// //   fan_coil_new_winding:           "fanCoilNewWinding",
// //   fan_coil_repair:                "fanCoilRepair",
// //   capacitor_setup:                "capacitorSetup",
// //   light_installation:             "lightInstallation",
// //   light_repair:                   "lightRepair",
// //   exhaust_fan_installation:       "exhaustFanInstallation",
// //   exhaust_fan_cleaning:           "exhaustFanCleaning",
// //   switch_setup:                   "switchSetup",
// //   socket_setup:                   "socketSetup",
// //   regulator_setup:                "regulatorSetup",
// //   new_wiring_point:               "newWiringPoint",
// //   main_circuit_board_setup:       "mainCircuitBoardSetup",
// //   doorbell_installation:          "doorbellInstallation",
// //   drill_hole_service:             "drillHoleService",
// //   ips_installation_existing_line: "ipsInstallationExistingLine",
// //   ips_new_line_installation:      "ipsNewLineInstallation",
// // };
// const ELEC_BOOL_FLAT = { Electrical_checkup: "checkupFlat" };


// // Plumber
// const MAP_PLUMBER = {
//   angle_valve_setup:                       "angleValveSetup",
//   basin_tap_setup:                         "basinTapSetup",
//   magic_pipe_setup:                        "magicPipeSetup",
//   basin_waste_pop_up_setup:                "basinWastePopUpSetup",
//   new_basin_setup_existing_lines:          "newBasinSetupExistingLines",

//   bathroom_tap_bib_cock_setup:             "bathroomTapBibCockSetup",
//   tissue_holder_setup:                     "tissueHolderSetup",
//   fill_valve_replacement:                  "fillValveReplacement",
//   hand_shower_setup:                       "handShowerSetup",
//   soap_dish_setup:                         "soapDishSetup",
//   bathroom_shelf_setup:                    "bathroomShelfSetup",
//   mirror_setup:                            "mirrorSetup",
//   towel_hanger_setup:                      "towelHangerSetup",
//   shower_head_setup:                       "showerHeadSetup",
//   concealed_stopcock_setup:                "concealedStopcockSetup",
//   floor_drain_net_setup:                   "floorDrainNetSetup",

//   toilet_seat_cover_replacement:           "toiletSeatCoverReplacement",
//   toilet_seat_complete_installation:       "toiletSeatCompleteInstallation",
//   high_commode_installation_existing_lines:"highCommodeInstallationExistingLines",
//   blockage_clearing_high_commode:          "blockageClearingHighCommode",
//   blockage_clearing_low_commode:           "blockageClearingLowCommode",

//   bathroom_drain_line_cleaning:            "bathroomDrainLineCleaning",
//   geyser_installation:                     "geyserInstallation",

//   kitchen_sink_setup_existing_lines:       "kitchenSinkSetupExistingLines",
//   sink_blockage_cleaning:                  "sinkBlockageCleaning",
//   washing_machine_point_setup:             "washingMachinePointSetup",
// };
// const PLUMBER_BOOL_FLAT = { issue_checkup: "issueCheckupFlat" };

// // Gas Chula
// const MAP_GAS = {
//   NewchulaSetup: "newChulaSetup",
//   chulaSetup: "chulaSetup",
//   burnerSetup: "burnerSetup",
//   burnerCleaning: "burnerCleaning",
//   nozzleReplacement: "nozzleReplacement",
// };
// const GAS_BOOL_FLAT = { checkIssues: "checkIssuesFlat" };

// // Filter
// const MAP_FILTER = {
//   new_filter_setup: "newFilterSetup",
//   installation_filter: "installationFilter",
//   uninstallation_filter: "uninstallationFilter",
//   kit_replacement: "kitReplacement",
//   pipe_leak_or_replace: "pipeLeakOrReplace",
//   full_servicing: "fullServicing",
// };
// const FILTER_BOOL_FLAT = { check_up: "checkupFlat" };

// // Home Cleaning
// const MAP_HOME_FIRSTFREE = {
//   bed: "bedrooms",
//   kitchen: "kitchens",
//   dra_din: "drawingdinning",
// };
// const MAP_HOME_PERUNIT = {
//   bath: "bathrooms",
//   cloth: "cloths",
//   dish: "dishes",
//   balcony: "balconies",
//   window_grill: "windowGrills",
//   furniture_cleaning: "furniture",
//   stairs_and_railing: "stairsFloors",
//   carpet_cleaning: "carpets",
// };

// // AC numeric props (per-unit tiered)
// const AC_NUMERIC_PROPS = new Set([
//   "installation_outdoor_inside",
//   "installation_outdoor_outside",
//   "uninstallation_outdoor_inside",
//   "uninstallation_outdoor_outside",
//   "cleaning_outdoor_inside",
//   "cleaning_outdoor_outside",
// ]);
// // AC checkup is numeric count of AC units
// const AC_CHECKUP_KEY = "issue_checkup";

// /* ----------------------------- helpers ----------------------------- */
// const acTierTotal = (prop, qty) => {
//   const c = Math.max(0, Number(qty) || 0);
//   if (!c) return 0;
//   const rate = AC_PRICING?.perUnit?.[prop];
//   if (!rate) return 0;
//   if (c === 1) return rate.first;
//   return c * rate.additional;
// };

// const acCheckupTotal = (qty) => {
//   const c = Math.max(0, Number(qty) || 0);
//   if (!c) return 0;
//   const { base = 0, includesUnits = 0, extraPerUnit = 0 } =
//     AC_PRICING?.checkup || {};
//   if (c <= includesUnits) return base;
//   return base + (c - includesUnits) * extraPerUnit;
// };

// /* ---------------------------------------------------------------------------------- */

// const ServiceEditModal = ({ show, onHide, order, URL, onApplied }) => {
//   const { t } = useTranslation();

//   const [note, setNote] = useState("");
//   const [extraMinutes, setExtraMinutes] = useState(0);
//   const [submitting, setSubmitting] = useState(false);

//   // Numeric increments to add (never negative). We keep ONLY the extra amount here.
//   const [numAdds, setNumAdds] = useState({}); // { prop: addQty }
//   // Boolean turn-ons (only allowed when current is false)
//   const [boolAdds, setBoolAdds] = useState({}); // { prop: true|false }

//   const serviceName = order?.service_name || "";
//   const isTutor = serviceName === "Tutor Service";
//   const svcPricing = SERVICE_PRICING[serviceName];

//   // Build editable field list from serviceFields for this service
//   const editableFields = useMemo(() => {
//     const fields = serviceFields[serviceName] || [];
//     // Only allow number & boolean types in this modal
//     return fields.filter((f) => f.type === "number" || f.type === "boolean");
//   }, [serviceName]);

//   // Stepper helpers: value shown to user is (current + add). We store only "add".
//   const inc = (prop) => {
//     setNumAdds((prev) => ({
//       ...prev,
//       [prop]: Math.max(0, (prev[prop] || 0) + 1),
//     }));
//   };
//   const dec = (prop) => {
//     setNumAdds((prev) => ({
//       ...prev,
//       [prop]: Math.max(0, (prev[prop] || 0) - 1),
//     }));
//   };

//   const handleNumberTyped = (prop, typed, cur) => {
//     // Clamp typed total to be >= current
//     const total = isNaN(typed) ? cur : Math.max(cur, typed);
//     const add = Math.max(0, total - cur);
//     setNumAdds((prev) => ({ ...prev, [prop]: add }));
//   };

//   const handleBoolChange = (prop, val) => {
//     // only "No change" (false) or "Add (Yes)" (true)
//     setBoolAdds((prev) => ({ ...prev, [prop]: val }));
//   };

//   // Return per-unit rate for service/prop (non-AC, non-home-firstfree)
//   const perUnitRate = useCallback((svc, prop) => {
//     if (!svcPricing) return 0;

//     if (svc === "Electrician") {
//       // const k = MAP_ELECTRICIAN[prop];
//       // return k ? svcPricing.perUnit?.[k] || 0 : 0;
//       return Number(svcPricing.perUnit?.[prop]) || 0;
//     }
//     if (svc === "Plumber") {
//       const k = MAP_PLUMBER[prop];
//       return k ? svcPricing.perUnit?.[k] || 0 : 0;
//     }
//     if (svc === "Gas Chula") {
//       const k = MAP_GAS[prop];
//       return k ? svcPricing.perUnit?.[k] || 0 : 0;
//     }
//     if (svc === "Filter") {
//       const k = MAP_FILTER[prop];
//       return k ? svcPricing.perUnit?.[k] || 0 : 0;
//     }
//     if (svc === "Home Cleaning") {
//       const k = MAP_HOME_PERUNIT[prop];
//       return k ? svcPricing.perUnit?.[k] || 0 : 0;
//     }
//     return 0;
//   }, [svcPricing]);

//   // Return boolean flat for service/prop
//   const booleanFlat = useCallback((svc, prop) => {
//     if (!svcPricing) return 0;
//     if (svc === "Electrician" && prop in ELEC_BOOL_FLAT) {
//       return svcPricing[ ELEC_BOOL_FLAT[prop] ] || 0;
//     }
//     if (svc === "Plumber" && prop in PLUMBER_BOOL_FLAT) {
//       return svcPricing[ PLUMBER_BOOL_FLAT[prop] ] || 0;
//     }
//     if (svc === "Gas Chula" && prop in GAS_BOOL_FLAT) {
//       return svcPricing[ GAS_BOOL_FLAT[prop] ] || 0;
//     }
//     if (svc === "Filter" && prop in FILTER_BOOL_FLAT) {
//       return svcPricing[ FILTER_BOOL_FLAT[prop] ] || 0;
//     }
//     return 0;
//   }, [svcPricing]);

//   // Build the payload for server (only include actual additions)
//   const buildItemsPayload = () => {
//     const items = [];

//     // number fields: include only when user added > 0 (we send the increment)
//     editableFields
//       .filter((f) => f.type === "number")
//       .forEach((f) => {
//         const addQty = Number(numAdds[f.prop] || 0);
//         if (addQty > 0) {
//           items.push({
//             code: f.prop,
//             title: t(f.labelKey),
//             qty: addQty,
//           });
//         }
//       });

//     // boolean fields: include only when currently false AND user selected "Add"
//     editableFields
//       .filter((f) => f.type === "boolean")
//       .forEach((f) => {
//         const cur = !!(order ? order[f.prop] : undefined);
//         const wantYes = !!boolAdds[f.prop];
//         if (!cur && wantYes) {
//           items.push({
//             code: f.prop,
//             title: t(f.labelKey),
//             qty: 1,
//           });
//         }
//       });

//     return items;
//   };

//   // Count of selected add-ons (no dependency on buildItemsPayload)
//   const selectedCount = useMemo(() => {
//     let count = 0;
//     editableFields.forEach((f) => {
//       if (f.type === "number") {
//         const add = Number(numAdds[f.prop] || 0);
//         if (add > 0) count++;
//       } else if (f.type === "boolean") {
//         const cur = !!(order ? order[f.prop] : undefined);
//         const wantYes = !!boolAdds[f.prop];
//         if (!cur && wantYes) count++;
//       }
//     });
//     return count;
//   }, [editableFields, numAdds, boolAdds, order]);

//   // ---------- Live estimate (per new pricing) ----------
//   const estimatedDelta = useMemo(() => {
//     if (!svcPricing) return 0;
//     let sum = 0;

//     // numeric increments
//     editableFields
//       .filter((f) => f.type === "number")
//       .forEach((f) => {
//         const add = Number(numAdds[f.prop] || 0);
//         if (add <= 0) return;

//         const cur = Number(order ? order[f.prop] || 0 : 0);
//         const svc = serviceName;

//         // AC Service (tier + numeric checkup)
//         if (svc === "AC Service") {
//           if (AC_NUMERIC_PROPS.has(f.prop)) {
//             const before = acTierTotal(f.prop, cur);
//             const after = acTierTotal(f.prop, cur + add);
//             sum += Math.max(0, after - before);
//             return;
//           }
//           if (f.prop === AC_CHECKUP_KEY) {
//             const before = acCheckupTotal(cur);
//             const after = acCheckupTotal(cur + add);
//             sum += Math.max(0, after - before);
//             return;
//           }
//           // anything else numeric in AC: no charge
//           return;
//         }

//         // Home Cleaning: first-free (bed/kitchen/dra_din)
//         if (svc === "Home Cleaning" && MAP_HOME_FIRSTFREE[f.prop]) {
//           const ffKey = MAP_HOME_FIRSTFREE[f.prop];
//           const perAdditional = svcPricing?.firstFree?.[ffKey]?.perAdditional || 0;
//           const before = Math.max(0, cur - 1);
//           const after = Math.max(0, cur + add - 1);
//           sum += (after - before) * perAdditional;
//           return;
//         }

//         // Plain per-unit (all other services & HC per-unit)
//         const unit = perUnitRate(svc, f.prop) || 0;
//         sum += unit * add;
//       });

//     // boolean: add one-time flat only if currently false and user selected "yes"
//     editableFields
//       .filter((f) => f.type === "boolean")
//       .forEach((f) => {
//         const svc = serviceName;
//         const cur = !!(order ? order[f.prop] : undefined);
//         const wantYes = !!boolAdds[f.prop];
//         if (!cur && wantYes) {
//           // AC has no boolean checkup anymore (it's numeric), so skip AC here
//           if (svc === "AC Service") return;
//           sum += booleanFlat(svc, f.prop) || 0;
//         }
//       });

//     // If you ever price extraMinutes on UI, add here. Server is still source of truth.

//     return Math.round(sum);
//   }, [editableFields, numAdds, boolAdds, order, serviceName, svcPricing, perUnitRate, booleanFlat]);

//   const submit = async () => {
//     const items = buildItemsPayload();
//     if (items.length === 0 && Number(extraMinutes) <= 0 && !note.trim()) {
//       alert(t("serviceEditModal.alerts.noItems"));
//       return;
//     }

//     setSubmitting(true);
//     try {
//       const token = localStorage.getItem("token");
//       const resp = await fetch(
//         `${URL}/orders/${order?.order_number}/change-requests`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             ...(token ? { Authorization: `Bearer ${token}` } : {}),
//           },
//           body: JSON.stringify({
//             serviceType: serviceName,
//             proposedBy: "user",
//             items,
//             extraMinutes: Number(extraMinutes) || 0,
//             note: note.trim(),
//           }),
//         }
//       );

//       if (!resp.ok) {
//         const txt = await resp.text();
//         throw new Error(txt || t("serviceEditModal.alerts.submitFailed"));
//       }
//       const data = await resp.json();
//       onApplied?.(data);
//     } catch (e) {
//       console.error(e);
//       alert(t("serviceEditModal.alerts.submitFailed"));
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const closeAndReset = () => {
//     setNumAdds({});
//     setBoolAdds({});
//     setExtraMinutes(0);
//     setNote("");
//     onHide();
//   };

//   // Safe guards (UI will still render even if order is not yet present, but with blanks)
//   const orderNumber = order?.order_number || "—";
//   const currentTotal = Number(order?.price ?? 0);
//   const prettyDeadline = order?.deadline
//     ? new Date(order.deadline).toLocaleString()
//     : null;

//   return (
//     <Modal
//       show={show}
//       onHide={closeAndReset}
//       centered
//       dialogClassName="service-edit-modal"
//     >
//       <Modal.Header closeButton>
//         <Modal.Title>{t("serviceEditModal.title")}</Modal.Title>
//       </Modal.Header>

//       <Modal.Body>
//         <div className="service-edit-summary">
//           <div>
//             <strong>{t("serviceEditModal.summary.orderNumber")}</strong>{" "}
//             {orderNumber}
//           </div>
//           <div>
//             <strong>{t("serviceEditModal.summary.service")}</strong>{" "}
//             {serviceName || "—"}
//           </div>
//           <div>
//             <strong>{t("serviceEditModal.summary.currentTotal")}</strong>{" "}
//             {currentTotal} tk
//           </div>
//           {prettyDeadline && (
//             <div>
//               <strong>{t("serviceEditModal.summary.deadline")}</strong>{" "}
//               {prettyDeadline}
//             </div>
//           )}
//           {isTutor && (
//             <div className="service-edit-tip">
//               {t("serviceEditModal.summary.tutorTip")}
//             </div>
//           )}
//         </div>

//         <hr />

//         {/* Editable numeric fields (show current value inside the input; user can only increase) */}
//         {editableFields.some((f) => f.type === "number") && (
//           <>
//             <h6 className="service-edit-section">
//               {t("serviceEditModal.sections.addQuantities")}
//             </h6>
//             <div className="service-edit-grid">
//               {editableFields
//                 .filter((f) => f.type === "number")
//                 .map((f) => {
//                   const cur = Number(order ? order[f.prop] || 0 : 0);
//                   const add = Number(numAdds[f.prop] || 0);
//                   const shownTotal = cur + add;
//                   return (
//                     <div key={f.prop} className="service-edit-row">
//                       <div className="service-edit-label">{t(f.labelKey)}</div>

//                       <div className="service-edit-stepper">
//                         <button
//                           className="stepper-btn"
//                           onClick={() => dec(f.prop)}
//                           disabled={add <= 0}
//                           aria-label="decrease"
//                         >
//                           −
//                         </button>

//                         <input
//                           type="number"
//                           className="stepper-input"
//                           value={shownTotal}
//                           min={cur}
//                           onChange={(e) =>
//                             handleNumberTyped(
//                               f.prop,
//                               parseInt(e.target.value || "0", 10),
//                               cur
//                             )
//                           }
//                         />

//                         <button
//                           className="stepper-btn"
//                           onClick={() => inc(f.prop)}
//                           aria-label="increase"
//                         >
//                           +
//                         </button>
//                       </div>
//                     </div>
//                   );
//                 })}
//             </div>
//           </>
//         )}

//         {/* Editable boolean fields */}
//         {editableFields.some((f) => f.type === "boolean") && (
//           <>
//             <h6 className="service-edit-section">
//               {t("serviceEditModal.sections.addOptions")}
//             </h6>
//             <div className="service-edit-grid">
//               {editableFields
//                 .filter((f) => f.type === "boolean")
//                 .map((f) => {
//                   const cur = !!(order ? order[f.prop] : undefined);
//                   const choice = !!boolAdds[f.prop];
//                   return (
//                     <div key={f.prop} className="service-edit-row">
//                       <div className="service-edit-label">{t(f.labelKey)}</div>
//                       <div>
//                         {cur ? (
//                           <span className="service-edit-tag">
//                             {t("serviceEditModal.booleanOptions.alreadyYes")}
//                           </span>
//                         ) : (
//                           <Form.Select
//                             className="service-edit-select"
//                             value={choice ? "yes" : "no"}
//                             onChange={(e) =>
//                               handleBoolChange(f.prop, e.target.value === "yes")
//                             }
//                           >
//                             <option value="no">
//                               {t("serviceEditModal.booleanOptions.noChange")}
//                             </option>
//                             <option value="yes">
//                               {t("serviceEditModal.booleanOptions.addYes")}
//                             </option>
//                           </Form.Select>
//                         )}
//                       </div>
//                     </div>
//                   );
//                 })}
//             </div>
//           </>
//         )}

//         {/* Extra time */}
//         {order?.status !== "In-Progress" && (
//           <>
//             <h6 className="service-edit-section">
//               {t("serviceEditModal.sections.extraTime")}
//             </h6>
//             <Form.Select
//               value={extraMinutes}
//               onChange={(e) => setExtraMinutes(parseInt(e.target.value, 10))}
//             >
//               <option value={0}>
//                 {t("serviceEditModal.extraTimeOptions.none")}
//               </option>
//               <option value={15}>
//                 {t("serviceEditModal.extraTimeOptions.15minutes")}
//               </option>
//               <option value={30}>
//                 {t("serviceEditModal.extraTimeOptions.30minutes")}
//               </option>
//               <option value={60}>
//                 {t("serviceEditModal.extraTimeOptions.60minutes")}
//               </option>
//               <option value={120}>
//                 {t("serviceEditModal.extraTimeOptions.120minutes")}
//               </option>
//             </Form.Select>
//           </>
//         )}

//         {/* Selection summary + price estimate */}
//         <div className="service-edit-summary mt-3">
//           <div>
//             <strong>
//               {t("serviceEditModal.summaryFields.selectedAddOns")}
//             </strong>{" "}
//             {selectedCount} item(s)
//           </div>
//           <div>
//             <strong>
//               {t("serviceEditModal.summaryFields.estimatedExtra")}
//             </strong>{" "}
//             {estimatedDelta} tk
//           </div>
//           <div>
//             <strong>{t("serviceEditModal.summaryFields.newTotal")}</strong>{" "}
//             {currentTotal + estimatedDelta} tk
//           </div>
//         </div>
//       </Modal.Body>

//       <Modal.Footer>
//         <Button
//           variant="secondary"
//           onClick={closeAndReset}
//           disabled={submitting}
//         >
//           {t("serviceEditModal.buttons.close")}
//         </Button>
//         <Button variant="primary" onClick={submit} disabled={submitting}>
//           {submitting ? (
//             <>
//               <Spinner
//                 animation="border"
//                 size="sm"
//                 style={{ marginRight: 8 }}
//               />
//               {t("serviceEditModal.buttons.submitting")}
//             </>
//           ) : (
//             t("serviceEditModal.buttons.submit")
//           )}
//         </Button>
//       </Modal.Footer>
//     </Modal>
//   );
// };

// export default ServiceEditModal;




// ***** Update New Update for drill holes electrician (1-january-2026) ***** //
import React, { useMemo, useState, useCallback  } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { serviceFields } from "../../Services/serviceFields";
import {
  SERVICE_PRICING,
  AC_PRICING,
} from "../../Services/servicePricing";
import "./ServiceEditmodal.css";

/* ----------------------------- field → pricing-key mappings ----------------------------- */
// Electrician
// const MAP_ELECTRICIAN = {
//   ceiling_fan_installation:       "ceilingFanInstallation",
//   ceiling_fan_uninstallation:     "ceilingFanUninstallation",
//   fan_coil_new_winding:           "fanCoilNewWinding",
//   fan_coil_repair:                "fanCoilRepair",
//   capacitor_setup:                "capacitorSetup",
//   light_installation:             "lightInstallation",
//   light_repair:                   "lightRepair",
//   exhaust_fan_installation:       "exhaustFanInstallation",
//   exhaust_fan_cleaning:           "exhaustFanCleaning",
//   switch_setup:                   "switchSetup",
//   socket_setup:                   "socketSetup",
//   regulator_setup:                "regulatorSetup",
//   new_wiring_point:               "newWiringPoint",
//   main_circuit_board_setup:       "mainCircuitBoardSetup",
//   doorbell_installation:          "doorbellInstallation",
//   drill_hole_service:             "drillHoleService",
//   ips_installation_existing_line: "ipsInstallationExistingLine",
//   ips_new_line_installation:      "ipsNewLineInstallation",
// };
const ELEC_BOOL_FLAT = { Electrical_checkup: "checkupFlat" };


// Plumber
const MAP_PLUMBER = {
  angle_valve_setup:                       "angleValveSetup",
  basin_tap_setup:                         "basinTapSetup",
  magic_pipe_setup:                        "magicPipeSetup",
  basin_waste_pop_up_setup:                "basinWastePopUpSetup",
  new_basin_setup_existing_lines:          "newBasinSetupExistingLines",

  bathroom_tap_bib_cock_setup:             "bathroomTapBibCockSetup",
  tissue_holder_setup:                     "tissueHolderSetup",
  fill_valve_replacement:                  "fillValveReplacement",
  hand_shower_setup:                       "handShowerSetup",
  soap_dish_setup:                         "soapDishSetup",
  bathroom_shelf_setup:                    "bathroomShelfSetup",
  mirror_setup:                            "mirrorSetup",
  towel_hanger_setup:                      "towelHangerSetup",
  shower_head_setup:                       "showerHeadSetup",
  concealed_stopcock_setup:                "concealedStopcockSetup",
  floor_drain_net_setup:                   "floorDrainNetSetup",

  toilet_seat_cover_replacement:           "toiletSeatCoverReplacement",
  toilet_seat_complete_installation:       "toiletSeatCompleteInstallation",
  high_commode_installation_existing_lines:"highCommodeInstallationExistingLines",
  blockage_clearing_high_commode:          "blockageClearingHighCommode",
  blockage_clearing_low_commode:           "blockageClearingLowCommode",

  bathroom_drain_line_cleaning:            "bathroomDrainLineCleaning",
  geyser_installation:                     "geyserInstallation",

  kitchen_sink_setup_existing_lines:       "kitchenSinkSetupExistingLines",
  sink_blockage_cleaning:                  "sinkBlockageCleaning",
  washing_machine_point_setup:             "washingMachinePointSetup",
};
const PLUMBER_BOOL_FLAT = { issue_checkup: "issueCheckupFlat" };

// Gas Chula
const MAP_GAS = {
  NewchulaSetup: "newChulaSetup",
  chulaSetup: "chulaSetup",
  burnerSetup: "burnerSetup",
  burnerCleaning: "burnerCleaning",
  nozzleReplacement: "nozzleReplacement",
};
const GAS_BOOL_FLAT = { checkIssues: "checkIssuesFlat" };

// Filter
const MAP_FILTER = {
  new_filter_setup: "newFilterSetup",
  installation_filter: "installationFilter",
  uninstallation_filter: "uninstallationFilter",
  kit_replacement: "kitReplacement",
  pipe_leak_or_replace: "pipeLeakOrReplace",
  full_servicing: "fullServicing",
};
const FILTER_BOOL_FLAT = { check_up: "checkupFlat" };

// Home Cleaning
const MAP_HOME_FIRSTFREE = {
  bed: "bedrooms",
  kitchen: "kitchens",
  dra_din: "drawingdinning",
};
const MAP_HOME_PERUNIT = {
  bath: "bathrooms",
  cloth: "cloths",
  dish: "dishes",
  balcony: "balconies",
  window_grill: "windowGrills",
  furniture_cleaning: "furniture",
  stairs_and_railing: "stairsFloors",
  carpet_cleaning: "carpets",
};

// AC numeric props (per-unit tiered)
const AC_NUMERIC_PROPS = new Set([
  "installation_outdoor_inside",
  "installation_outdoor_outside",
  "uninstallation_outdoor_inside",
  "uninstallation_outdoor_outside",
  "cleaning_outdoor_inside",
  "cleaning_outdoor_outside",
]);
// AC checkup is numeric count of AC units
const AC_CHECKUP_KEY = "issue_checkup";

/* ----------------------------- helpers ----------------------------- */
const acTierTotal = (prop, qty) => {
  const c = Math.max(0, Number(qty) || 0);
  if (!c) return 0;
  const rate = AC_PRICING?.perUnit?.[prop];
  if (!rate) return 0;
  if (c === 1) return rate.first;
  return c * rate.additional;
};

const acCheckupTotal = (qty) => {
  const c = Math.max(0, Number(qty) || 0);
  if (!c) return 0;
  const { base = 0, includesUnits = 0, extraPerUnit = 0 } =
    AC_PRICING?.checkup || {};
  if (c <= includesUnits) return base;
  return base + (c - includesUnits) * extraPerUnit;
};


// Electrician drill-hole tier helper: { first, additional }
const firstAdditionalTotal = (rate, qty) => {
  const q = Math.max(0, Number(qty) || 0);
  if (!q) return 0;

  const first = Number(rate?.first ?? 0);
  const additional = Number(rate?.additional ?? rate?.first ?? 0);

  return first + Math.max(0, q - 1) * additional;
};

/* ---------------------------------------------------------------------------------- */

const ServiceEditModal = ({ show, onHide, order, URL, onApplied }) => {
  const { t } = useTranslation();

  const [note, setNote] = useState("");
  const [extraMinutes, setExtraMinutes] = useState(0);
  const [submitting, setSubmitting] = useState(false);

  // Numeric increments to add (never negative). We keep ONLY the extra amount here.
  const [numAdds, setNumAdds] = useState({}); // { prop: addQty }
  // Boolean turn-ons (only allowed when current is false)
  const [boolAdds, setBoolAdds] = useState({}); // { prop: true|false }

  const serviceName = order?.service_name || "";
  const isTutor = serviceName === "Tutor Service";
  const svcPricing = SERVICE_PRICING[serviceName];

  // Build editable field list from serviceFields for this service
  const editableFields = useMemo(() => {
    const fields = serviceFields[serviceName] || [];
    // Only allow number & boolean types in this modal
    return fields.filter((f) => f.type === "number" || f.type === "boolean");
  }, [serviceName]);

  // Stepper helpers: value shown to user is (current + add). We store only "add".
  const inc = (prop) => {
    setNumAdds((prev) => ({
      ...prev,
      [prop]: Math.max(0, (prev[prop] || 0) + 1),
    }));
  };
  const dec = (prop) => {
    setNumAdds((prev) => ({
      ...prev,
      [prop]: Math.max(0, (prev[prop] || 0) - 1),
    }));
  };

  const handleNumberTyped = (prop, typed, cur) => {
    // Clamp typed total to be >= current
    const total = isNaN(typed) ? cur : Math.max(cur, typed);
    const add = Math.max(0, total - cur);
    setNumAdds((prev) => ({ ...prev, [prop]: add }));
  };

  const handleBoolChange = (prop, val) => {
    // only "No change" (false) or "Add (Yes)" (true)
    setBoolAdds((prev) => ({ ...prev, [prop]: val }));
  };

  // Return per-unit rate for service/prop (non-AC, non-home-firstfree)
  const perUnitRate = useCallback((svc, prop) => {
    if (!svcPricing) return 0;

    // if (svc === "Electrician") {
    //   // const k = MAP_ELECTRICIAN[prop];
    //   // return k ? svcPricing.perUnit?.[k] || 0 : 0;
    //   return Number(svcPricing.perUnit?.[prop]) || 0;
    // }

    if (svc === "Electrician") {
      const rate = svcPricing.perUnit?.[prop];

      // drill hole is tiered: { first, additional }
      if (prop === "drill_hole_service" && rate && typeof rate === "object") {
        return rate;
      }

      // all other electrician items are normal numbers
      return Number(rate) || 0;
    }

    if (svc === "Plumber") {
      const k = MAP_PLUMBER[prop];
      return k ? svcPricing.perUnit?.[k] || 0 : 0;
    }
    if (svc === "Gas Chula") {
      const k = MAP_GAS[prop];
      return k ? svcPricing.perUnit?.[k] || 0 : 0;
    }
    if (svc === "Filter") {
      const k = MAP_FILTER[prop];
      return k ? svcPricing.perUnit?.[k] || 0 : 0;
    }
    if (svc === "Home Cleaning") {
      const k = MAP_HOME_PERUNIT[prop];
      return k ? svcPricing.perUnit?.[k] || 0 : 0;
    }
    return 0;
  }, [svcPricing]);

  // Return boolean flat for service/prop
  const booleanFlat = useCallback((svc, prop) => {
    if (!svcPricing) return 0;
    if (svc === "Electrician" && prop in ELEC_BOOL_FLAT) {
      return svcPricing[ ELEC_BOOL_FLAT[prop] ] || 0;
    }
    if (svc === "Plumber" && prop in PLUMBER_BOOL_FLAT) {
      return svcPricing[ PLUMBER_BOOL_FLAT[prop] ] || 0;
    }
    if (svc === "Gas Chula" && prop in GAS_BOOL_FLAT) {
      return svcPricing[ GAS_BOOL_FLAT[prop] ] || 0;
    }
    if (svc === "Filter" && prop in FILTER_BOOL_FLAT) {
      return svcPricing[ FILTER_BOOL_FLAT[prop] ] || 0;
    }
    return 0;
  }, [svcPricing]);

  // Build the payload for server (only include actual additions)
  const buildItemsPayload = () => {
    const items = [];

    // number fields: include only when user added > 0 (we send the increment)
    editableFields
      .filter((f) => f.type === "number")
      .forEach((f) => {
        const addQty = Number(numAdds[f.prop] || 0);
        if (addQty > 0) {
          items.push({
            code: f.prop,
            title: t(f.labelKey),
            qty: addQty,
          });
        }
      });

    // boolean fields: include only when currently false AND user selected "Add"
    editableFields
      .filter((f) => f.type === "boolean")
      .forEach((f) => {
        const cur = !!(order ? order[f.prop] : undefined);
        const wantYes = !!boolAdds[f.prop];
        if (!cur && wantYes) {
          items.push({
            code: f.prop,
            title: t(f.labelKey),
            qty: 1,
          });
        }
      });

    return items;
  };

  // Count of selected add-ons (no dependency on buildItemsPayload)
  const selectedCount = useMemo(() => {
    let count = 0;
    editableFields.forEach((f) => {
      if (f.type === "number") {
        const add = Number(numAdds[f.prop] || 0);
        if (add > 0) count++;
      } else if (f.type === "boolean") {
        const cur = !!(order ? order[f.prop] : undefined);
        const wantYes = !!boolAdds[f.prop];
        if (!cur && wantYes) count++;
      }
    });
    return count;
  }, [editableFields, numAdds, boolAdds, order]);

  // ---------- Live estimate (per new pricing) ----------
  const estimatedDelta = useMemo(() => {
    if (!svcPricing) return 0;
    let sum = 0;

    // numeric increments
    editableFields
      .filter((f) => f.type === "number")
      .forEach((f) => {
        const add = Number(numAdds[f.prop] || 0);
        if (add <= 0) return;

        const cur = Number(order ? order[f.prop] || 0 : 0);
        const svc = serviceName;

        // AC Service (tier + numeric checkup)
        if (svc === "AC Service") {
          if (AC_NUMERIC_PROPS.has(f.prop)) {
            const before = acTierTotal(f.prop, cur);
            const after = acTierTotal(f.prop, cur + add);
            sum += Math.max(0, after - before);
            return;
          }
          if (f.prop === AC_CHECKUP_KEY) {
            const before = acCheckupTotal(cur);
            const after = acCheckupTotal(cur + add);
            sum += Math.max(0, after - before);
            return;
          }
          // anything else numeric in AC: no charge
          return;
        }

        // Home Cleaning: first-free (bed/kitchen/dra_din)
        if (svc === "Home Cleaning" && MAP_HOME_FIRSTFREE[f.prop]) {
          const ffKey = MAP_HOME_FIRSTFREE[f.prop];
          const perAdditional = svcPricing?.firstFree?.[ffKey]?.perAdditional || 0;
          const before = Math.max(0, cur - 1);
          const after = Math.max(0, cur + add - 1);
          sum += (after - before) * perAdditional;
          return;
        }

        // Plain per-unit (all other services & HC per-unit)
        // const unit = perUnitRate(svc, f.prop) || 0;
        // sum += unit * add;

        const rate = perUnitRate(svc, f.prop);

          // normal number pricing
          if (typeof rate === "number") {
            sum += rate * add;
            return;
          }

          // drill-hole tier object pricing
          if (rate && typeof rate === "object") {
            const before = firstAdditionalTotal(rate, cur);
            const after = firstAdditionalTotal(rate, cur + add);
            sum += Math.max(0, after - before);
            return;
          }

      });

    // boolean: add one-time flat only if currently false and user selected "yes"
    editableFields
      .filter((f) => f.type === "boolean")
      .forEach((f) => {
        const svc = serviceName;
        const cur = !!(order ? order[f.prop] : undefined);
        const wantYes = !!boolAdds[f.prop];
        if (!cur && wantYes) {
          // AC has no boolean checkup anymore (it's numeric), so skip AC here
          if (svc === "AC Service") return;
          sum += booleanFlat(svc, f.prop) || 0;
        }
      });

    // If you ever price extraMinutes on UI, add here. Server is still source of truth.

    return Math.round(sum);
  }, [editableFields, numAdds, boolAdds, order, serviceName, svcPricing, perUnitRate, booleanFlat]);

  const submit = async () => {
    const items = buildItemsPayload();
    if (items.length === 0 && Number(extraMinutes) <= 0 && !note.trim()) {
      alert(t("serviceEditModal.alerts.noItems"));
      return;
    }

    setSubmitting(true);
    try {
      const token = localStorage.getItem("token");
      const resp = await fetch(
        `${URL}/orders/${order?.order_number}/change-requests`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
          body: JSON.stringify({
            serviceType: serviceName,
            proposedBy: "user",
            items,
            extraMinutes: Number(extraMinutes) || 0,
            note: note.trim(),
          }),
        }
      );

      if (!resp.ok) {
        const txt = await resp.text();
        throw new Error(txt || t("serviceEditModal.alerts.submitFailed"));
      }
      const data = await resp.json();
      onApplied?.(data);
    } catch (e) {
      console.error(e);
      alert(t("serviceEditModal.alerts.submitFailed"));
    } finally {
      setSubmitting(false);
    }
  };

  const closeAndReset = () => {
    setNumAdds({});
    setBoolAdds({});
    setExtraMinutes(0);
    setNote("");
    onHide();
  };

  // Safe guards (UI will still render even if order is not yet present, but with blanks)
  const orderNumber = order?.order_number || "—";
  const currentTotal = Number(order?.price ?? 0);
  const prettyDeadline = order?.deadline
    ? new Date(order.deadline).toLocaleString()
    : null;

  return (
    <Modal
      show={show}
      onHide={closeAndReset}
      centered
      dialogClassName="service-edit-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>{t("serviceEditModal.title")}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="service-edit-summary">
          <div>
            <strong>{t("serviceEditModal.summary.orderNumber")}</strong>{" "}
            {orderNumber}
          </div>
          <div>
            <strong>{t("serviceEditModal.summary.service")}</strong>{" "}
            {serviceName || "—"}
          </div>
          <div>
            <strong>{t("serviceEditModal.summary.currentTotal")}</strong>{" "}
            {currentTotal} tk
          </div>
          {prettyDeadline && (
            <div>
              <strong>{t("serviceEditModal.summary.deadline")}</strong>{" "}
              {prettyDeadline}
            </div>
          )}
          {isTutor && (
            <div className="service-edit-tip">
              {t("serviceEditModal.summary.tutorTip")}
            </div>
          )}
        </div>

        <hr />

        {/* Editable numeric fields (show current value inside the input; user can only increase) */}
        {editableFields.some((f) => f.type === "number") && (
          <>
            <h6 className="service-edit-section">
              {t("serviceEditModal.sections.addQuantities")}
            </h6>
            <div className="service-edit-grid">
              {editableFields
                .filter((f) => f.type === "number")
                .map((f) => {
                  const cur = Number(order ? order[f.prop] || 0 : 0);
                  const add = Number(numAdds[f.prop] || 0);
                  const shownTotal = cur + add;
                  return (
                    <div key={f.prop} className="service-edit-row">
                      <div className="service-edit-label">{t(f.labelKey)}</div>

                      <div className="service-edit-stepper">
                        <button
                          className="stepper-btn"
                          onClick={() => dec(f.prop)}
                          disabled={add <= 0}
                          aria-label="decrease"
                        >
                          −
                        </button>

                        <input
                          type="number"
                          className="stepper-input"
                          value={shownTotal}
                          min={cur}
                          onChange={(e) =>
                            handleNumberTyped(
                              f.prop,
                              parseInt(e.target.value || "0", 10),
                              cur
                            )
                          }
                        />

                        <button
                          className="stepper-btn"
                          onClick={() => inc(f.prop)}
                          aria-label="increase"
                        >
                          +
                        </button>
                      </div>
                    </div>
                  );
                })}
            </div>
          </>
        )}

        {/* Editable boolean fields */}
        {editableFields.some((f) => f.type === "boolean") && (
          <>
            <h6 className="service-edit-section">
              {t("serviceEditModal.sections.addOptions")}
            </h6>
            <div className="service-edit-grid">
              {editableFields
                .filter((f) => f.type === "boolean")
                .map((f) => {
                  const cur = !!(order ? order[f.prop] : undefined);
                  const choice = !!boolAdds[f.prop];
                  return (
                    <div key={f.prop} className="service-edit-row">
                      <div className="service-edit-label">{t(f.labelKey)}</div>
                      <div>
                        {cur ? (
                          <span className="service-edit-tag">
                            {t("serviceEditModal.booleanOptions.alreadyYes")}
                          </span>
                        ) : (
                          <Form.Select
                            className="service-edit-select"
                            value={choice ? "yes" : "no"}
                            onChange={(e) =>
                              handleBoolChange(f.prop, e.target.value === "yes")
                            }
                          >
                            <option value="no">
                              {t("serviceEditModal.booleanOptions.noChange")}
                            </option>
                            <option value="yes">
                              {t("serviceEditModal.booleanOptions.addYes")}
                            </option>
                          </Form.Select>
                        )}
                      </div>
                    </div>
                  );
                })}
            </div>
          </>
        )}

        {/* Extra time */}
        {order?.status !== "In-Progress" && (
          <>
            <h6 className="service-edit-section">
              {t("serviceEditModal.sections.extraTime")}
            </h6>
            <Form.Select
              value={extraMinutes}
              onChange={(e) => setExtraMinutes(parseInt(e.target.value, 10))}
            >
              <option value={0}>
                {t("serviceEditModal.extraTimeOptions.none")}
              </option>
              <option value={15}>
                {t("serviceEditModal.extraTimeOptions.15minutes")}
              </option>
              <option value={30}>
                {t("serviceEditModal.extraTimeOptions.30minutes")}
              </option>
              <option value={60}>
                {t("serviceEditModal.extraTimeOptions.60minutes")}
              </option>
              <option value={120}>
                {t("serviceEditModal.extraTimeOptions.120minutes")}
              </option>
            </Form.Select>
          </>
        )}

        {/* Selection summary + price estimate */}
        <div className="service-edit-summary mt-3">
          <div>
            <strong>
              {t("serviceEditModal.summaryFields.selectedAddOns")}
            </strong>{" "}
            {selectedCount} item(s)
          </div>
          <div>
            <strong>
              {t("serviceEditModal.summaryFields.estimatedExtra")}
            </strong>{" "}
            {estimatedDelta} tk
          </div>
          {/* <div>
            <strong>{t("serviceEditModal.summaryFields.newTotal")}</strong>{" "}
            {currentTotal + estimatedDelta} tk
          </div> */}
          <small style={{ opacity: 0.7 }}>
            Final total may change because platform fee depends on subtotal.
          </small>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={closeAndReset}
          disabled={submitting}
        >
          {t("serviceEditModal.buttons.close")}
        </Button>
        <Button variant="primary" onClick={submit} disabled={submitting}>
          {submitting ? (
            <>
              <Spinner
                animation="border"
                size="sm"
                style={{ marginRight: 8 }}
              />
              {t("serviceEditModal.buttons.submitting")}
            </>
          ) : (
            t("serviceEditModal.buttons.submit")
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ServiceEditModal;
